import { inviteDetailsPresenter as presenter } from './services/inviteDetailsPresenter';
import { Divider, Image } from 'wix-style-react';
import { InviteDetails } from '../../types';
import styles from './index.scss';
import React from 'react';
import { i18n } from '../../services/i18n';
import { downloadService } from './services/download-link';
import { biLogger } from '../../services/bi';

type OwnProps = {
  inviteDetails: InviteDetails;
};

type Props = OwnProps;

class MobileLayout extends React.Component<Props> {
  onPressDownload = (origin: 'appstore' | 'googleplay' | 'button') => {
    const { inviteDetails } = this.props;
    biLogger.downloadClicked(inviteDetails, origin);
    downloadService.openLink(inviteDetails);
  };

  renderFooter = () => {
    const { inviteDetails } = this.props;
    const isBranded = inviteDetails.appType === 'WixBrandedApp';
    return (
      <div>
        <div className={styles.buttons}>
          <button
            data-hook="download-button"
            className={styles.downloadButton}
            onClick={() => this.onPressDownload('button')}
            style={{
              background: presenter.getDownloadCtaColor(inviteDetails.appType),
            }}
          >
            {i18n('lp.mobile.1st.download.cta')}
          </button>
          {!isBranded && (
            <Image
              dataHook="app-logo"
              className={styles.appLogo}
              fit="contain"
              transparent
              src={presenter.getAppLogo(this.props.inviteDetails.appType)}
              height={23}
            />
          )}
        </div>
        <div className={styles.footer}>
          <div className={styles.footDivider}>
            <Divider direction="horizontal" skin="light" />
          </div>
          <div className={styles.storesContainer}>
            <Image
              transparent
              className={styles.logoLeft}
              dataHook="google-play-logo"
              src={presenter.getGooglePlayLogo()}
              onClick={() => this.onPressDownload('googleplay')}
            />
            <Image
              transparent
              dataHook="app-store-logo"
              className={styles.logoRight}
              src={presenter.getAppStoreLogo()}
              onClick={() => this.onPressDownload('appstore')}
            />
          </div>
        </div>
      </div>
    );
  };

  renderHeader = () => {
    const { inviteDetails } = this.props;
    return (
      <div className={styles.header}>
        <Image
          fit="cover"
          height="100%"
          width="100%"
          borderRadius={0}
          src={presenter.getCoverImage(inviteDetails)}
          dataHook="cover-image"
          />
        <Image
          borderRadius={20}
          src={presenter.getPlaceImage(inviteDetails)}
          className={styles.siteLogo}
          fit="cover"
          dataHook="place-image"
        />
      </div>
    );
  };

  renderSecondLevelHeader = () => {
    const { inviteDetails } = this.props;
    return (
      <div className={styles.secondLevelHeader}>
        <Image
          fit="cover"
          height="85%"
          width="85%"
          borderRadius={12}
          style={{ margin: '2.82vh', marginBottom: 0 }}
          src={presenter.getItemImage(inviteDetails)}
        />
        <Image
          src={presenter.getPlaceImage(inviteDetails)}
          className={styles.secondLevelSiteLogo}
          borderRadius={16}
          fit="contain"
        />
      </div>
    );
  };

  renderContent = () => {
    const { inviteDetails } = this.props;
    const { inviteLevel } = inviteDetails;
    return (
      <div
        className={
          inviteLevel === '1st'
            ? styles.contentContainer
            : styles.secondLevelContentContainer
        }
      >
        <div
          className={
            inviteLevel === '1st'
              ? styles.contentContainerInner
              : styles.secondLevelContentContainerInner
          }
        >
          <div className={styles.mainTitle} data-hook="main-title">
            {presenter.getTitle(inviteDetails)}
          </div>
          <strong className={styles.secondaryTitle} data-hook="secondary-title">
            {presenter.getSubtitle(inviteDetails)}
          </strong>
        </div>
      </div>
    );
  };

  render = () => {
    const { inviteLevel } = this.props.inviteDetails;
    return (
      <div className={styles.container}>
        {inviteLevel === '1st'
          ? this.renderHeader()
          : this.renderSecondLevelHeader()}
        {this.renderContent()}
        {this.renderFooter()}
      </div>
    );
  };
}

export default MobileLayout;
